<template>
  <el-dialog
    :visible.sync="visible"
    :show-close="true"
    width="852px"
    custom-class="edit-union-container"
    @close="handleClose"
  >
    <template #title>
      <div class="modal-title">兰斯特洛行动</div>
    </template>
    <div class="union-content">
      <div class="role-action">
        <span class="label">角色行动：</span>
        <div
          :class="['action-item', { active: item.key === unionInfos.actionType }]"
          v-for="item in actionTypeList"
          :key="item.key"
          @click="handleCurrentAction(item.key)"
        >
          {{ item.label }}
        </div>
      </div>
      <div v-if="unionInfos.actionType !== 'dead'" class="clothing-box">
        <div class="title">
          选择技能：
        </div>
        <div :class="['cloth-line']">
          <div
            v-for="item in skillList"
            :key="item.name"
            :class="['cloth-card', { active: item.name === unionInfos.skill }]"
            @click="handleChooseSkill(item.name)"
          >
            <div class="box">
              <img :src="item.url" alt="" />
            </div>
            <div class="footer">
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="card-box">
          <div class="header">
            兰斯洛特技能效果
          </div>
          <div class="content">
            <div class="choose-line">
              <el-radio-group v-model="unionInfos.level">
                <el-radio v-for="item in levelArr" :key="item.level" :label="item.level">
                  {{ item.label }}
                </el-radio>
              </el-radio-group>
            </div>
            <div class="info-box">
              <div class="range">
                <span class="header">
                  范围
                </span>
                <div class="inner-box">
                  <img v-if="unionInfos.level === 2" class="img" src="@/assets/zs_imgs/battle/union_skill_2.png" />
                  <img v-else class="img" src="@/assets/zs_imgs/battle/union_skill.png" />
                </div>
              </div>
              <div class="info-content">
                <pre class="des">{{ currentDesc }}</pre>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { unionDict } from "@/views/wiki/battle/dict";

export default {
  props: {
    current: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      unionDict,
      visible: false,
      unionInfos: {
        actionType: "dead",
        skill: "",
        level: 1
      },
      skillList: [
        {
          name: "救赎之击",
          url: require("@/assets/zs_imgs/battle/救赎之击.webp")
        },
        {
          name: "阿隆戴特的狂潮",
          url: require("@/assets/zs_imgs/battle/阿隆戴特的狂潮.webp")
        },
        {
          name: "辉煌武技",
          url: require("@/assets/zs_imgs/battle/辉煌武技.webp")
        },
        {
          name: "湖畔庇佑",
          url: require("@/assets/zs_imgs/battle/湖畔庇佑.webp")
        }
      ],
      levelArr: [
        {
          level: 1,
          label: "Lv.1"
        },
        {
          level: 2,
          label: "Lv.2"
        },
        {
          level: 3,
          label: "Lv.3"
        },
        {
          level: 4,
          label: "Lv.4"
        },
        {
          level: 5,
          label: "Lv.5"
        }
      ],
      actionTypeList: [
        {
          key: "dead",
          label: "待命"
        },
        {
          key: "battle",
          label: "出战"
        }
      ]
    };
  },
  computed: {
    currentDesc() {
      const { skill, level } = this.unionInfos;
      if (!skill || !level) return "";
      return this.unionDict[`${skill}-${level}`];
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.unionInfos = {
          actionType: this.current.actionType || "dead",
          skill: this.current.skill || "",
          level: this.current.level || 1
        };
      }
    }
  },
  methods: {
    handleCurrentAction(key) {
      if (this.unionInfos.actionType === key) return;
      this.unionInfos.actionType = key;
    },
    handleChooseSkill(name) {
      if (this.unionInfos.skill === name) return;
      this.unionInfos.skill = name;
    },
    handleClose() {
      this.visible = false;

      this.$emit("updateUnion", JSON.parse(JSON.stringify(this.unionInfos)));

      this.unionInfos = {
        actionType: "dead",
        skill: "",
        level: 1
      };
    }
  }
};
</script>
<style lang="less">
.edit-union-container {
  background: linear-gradient(180deg, #cec1b5 0%, #a29a92 100%);
  .el-dialog__header {
    display: flex;
    align-items: center;
    height: 57px;
    padding: 0 20px;
    color: #333;
    font-size: 18px;
    font-weight: 600;
  }
  .el-dialog__body {
    padding: 0 12px 12px;
    .union-content {
      border-radius: 8px;
      background-color: #fff;
      .role-action {
        display: flex;
        align-items: center;
        height: 78px;
        padding: 0 20px;
        box-sizing: border-box;

        .label {
          margin-right: 8px;
          color: #333333;
          font-size: 14px;
        }
        .action-item {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 84px;
          height: 30px;
          margin-right: 16px;
          border-radius: 16px;
          background-color: transparent;
          border: 1px solid #d7d7d7;
          color: #999999;
          font-size: 14px;
          cursor: pointer;
          &:last-child {
            margin-right: 0;
          }
          &.active {
            background-color: #967a5f;
            border-color: #967a5f;
            color: #fff;
          }
        }
      }
      .clothing-box {
        padding: 20px;
        border-top: 1px solid #eaeaea;
        .title {
          margin-bottom: 18px;
          color: #333;
          font-size: 14px;
        }
        .cloth-line {
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          .cloth-card {
            display: flex;
            flex-direction: column;
            width: 100px;
            height: 128px;
            margin-right: 12px;
            transition: all 0.3s;
            border-radius: 4px;
            border: 2px solid transparent;
            cursor: pointer;
            box-sizing: border-box;
            background-color: #f7f1ee;
            &:last-child {
              margin-right: 0;
            }
            &.active {
              border: 2px solid #967a5f;
            }
            .box {
              display: flex;
              justify-content: center;
              align-items: center;
              flex: 1;
              img {
                width: 70px;
                height: 70px;
                object-fit: cover;
                border-radius: 50%;
              }
            }
            .footer {
              display: flex;
              align-items: center;
              justify-content: center;
              flex: 0 0 auto;
              width: 100%;
              height: 24px;
              color: #fff;
              font-size: 12px;
              background: #665f5d;
            }
          }
        }
        .card-box {
          .header {
            flex: 0 0 auto;
            display: flex;
            align-items: center;
            justify-content: center;
            // padding-left: 15px;
            height: 40px;
            color: #5a4434;
            font-size: 14px;
            font-weight: bold;
            background-color: #ddd6ce;
            border-radius: 8px 8px 0 0;
          }
          .content {
            padding: 0 18px 14px;
            background-color: #f7f5f4;
            border-radius: 0 0 8px 8px;
            .choose-line {
              display: flex;
              align-items: center;
              height: 52px;
              border-bottom: 1px solid rgba(216, 206, 199, 0.42);
              .el-radio-group {
                .el-radio {
                  &.is-checked {
                    .el-radio__input {
                      .el-radio__inner {
                        background-color: #8c6d5a;
                        border-color: #8c6d5a;
                      }
                    }
                    .el-radio__label {
                      color: #665f5d;
                    }
                  }
                  .el-radio__input {
                    .el-radio__inner {
                      background-color: rgba(140, 109, 90, 0.14);
                      border-color: rgba(140, 109, 90, 0.38);
                    }
                  }
                  .el-radio__label {
                    color: #999;
                    font-size: 14px;
                  }
                }
              }
            }
            .info-box {
              display: flex;
              padding: 15px 0;
              .range {
                text-align: center;
                flex: 0 0 auto;
                margin-right: 20px;
                width: 89px;
                height: 107px;
                border-radius: 4px;
                overflow: hidden;
                .header {
                  display: flex;
                  align-items: center;
                  height: 30px;
                  color: #5a4434;
                  font-size: 14px;
                  background-color: #dfd6d0;
                }
                .inner-box {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  height: 77px;
                  background-color: #f3ecea;
                  .img {
                    width: 36px;
                    height: 36px;
                    object-fit: cover;
                  }
                }
              }
              .info-content {
                display: flex;
                justify-content: center;
                align-items: center;
                color: #666666;
                font-size: 12px;
                line-height: 14px;
                pre {
                  white-space: pre-wrap;
                  word-wrap: break-word;
                  margin: 0;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
